// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"fda-z"};